import { Directive, HostListener, EventEmitter, Output, Input } from '@angular/core';
import * as _ from 'lodash-es';


@Directive({
    selector: '[smp-dropzone]'
})
export class DropzoneDirective {

    @Input()
    private allowed_extensions?: Array<string> = [];

    @Output()
    private filesChangeEmitter: EventEmitter<File[]> = new EventEmitter();

    @Output()
    private filesInvalidEmitter: EventEmitter<File[]> = new EventEmitter();

    @Output()
    private dragging: EventEmitter<boolean> = new EventEmitter();

    constructor() { }

    @HostListener('dragover', ['$event']) public onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.dragging.emit(true);
    }

    @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.dragging.emit(false);
    }

    @HostListener('drop', ['$event']) public onDrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        const files = evt.dataTransfer.files;
        const valid_files: Array<File> = [];
        const invalid_files: Array<File> = [];
        if (files.length > 0) {
            _.each(files, (file: File) => {
                const ext = file.name.split('.')[file.name.split('.').length - 1];
                if (!this.allowed_extensions || this.allowed_extensions.length === 0 || this.allowed_extensions.lastIndexOf(ext.toLowerCase()) !== -1) {
                    valid_files.push(file);
                } else {
                    invalid_files.push(file);
                }
            });
            this.filesChangeEmitter.emit(valid_files);
            this.filesInvalidEmitter.emit(invalid_files);
        }
        this.dragging.emit(false);
    }

}
